export enum CalculatorValueType {
    PRICE,
    CONTRIBUTION,
    PERIOD,
    AGE,
    EARNINGS,
    AVERAGE_EARNINGS,
    HOUSEHOLD_EXPENSES,
    LOAN_INSTALLMENTS
}
export enum CalculatorValueType {
    PRICE,
    CONTRIBUTION,
    PERIOD,
    AGE,
    EARNINGS,
    AVERAGE_EARNINGS,
    HOUSEHOLD_EXPENSES,
    LOAN_INSTALLMENTS
}
